var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @packageDocumentation
 * @module      PseudoMenuItem.ts
 * @description Encapsulates content that should appear in a menu (e.g., the Settings menu) but that is not
 *              a true menu item.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
import { LitElement, html, customElement, css } from 'lit-element';
/**
 * Encapsulates content that should appear in a menu (e.g., the Settings menu) but that is not suitable for being
 * an sh-menu-item
 * @noInheritDoc
 */
let PseudoMenuItem = class PseudoMenuItem extends LitElement {
    static get styles() {
        return css `
          div {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        `;
    }
    ;
    render() {
        return html `
            <div>
                <slot></slot>
            </div>
        `;
    }
};
PseudoMenuItem = __decorate([
    customElement('pseudo-menu-item')
], PseudoMenuItem);
export default PseudoMenuItem;
//# sourceMappingURL=PseudoMenuItem.js.map